import * as React from "react";
import Box from '@mui/material/Box';
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import { ReactComponent as CalendarIcon } from 'images/icons/calendar.svg';
import { ReactComponent as LocationPin } from 'images/icons/map-pin.svg';

const EventCard = ({uri, title, subtitle, date, location, className = ''}) => {
	const [animateClass, setAnimateClass] = React.useState('');

	const triggerAnimation = () => {
		setAnimateClass('animate');
		setTimeout(() => {
			setAnimateClass('');
		}, 600);
	}

	return (
		<Card className={[`eventCard__card ${className}`, animateClass].join(' ')}
			onMouseEnter={() => triggerAnimation()}
			onMouseLeave={() => triggerAnimation()}
			onFocus={() => triggerAnimation()}
			onBlur={() => triggerAnimation()}
		>
			<div className="eventCard__overlay" />
			<CardActionArea className={`eventCard__actionArea`} href={uri}>
				<CardContent className="eventCard__content">
					<Box className="eventCard__content__titleArea">
						{subtitle && (
							<Typography variant="h6" component="div" className="eventCard__cardSubtitle">
								{subtitle}
							</Typography>
						)}
						<Typography
							variant="h4"
							component="div"
							className={`eventCard__cardTitle`}
						>
							{title}
						</Typography>
					</Box>
					<Box className="eventCard__content__infoArea">
						{date && (
							<Box className="eventCard__cardDate eventCard__cardIconRow">
								<CalendarIcon className="eventCard__cardIcon calendarIcon" /><Typography variant="p" component="div">
									{date}
								</Typography>
							</Box>
						)}
						{location && (
							<Box className="eventCard__cardLocation eventCard__cardIconRow">
								<LocationPin className="eventCard__cardIcon locationPin" /><Typography variant="p" component="div">
									{location}
								</Typography>
							</Box>
						)}
					</Box>
				</CardContent>
			</CardActionArea>
		</Card>
	)
}

export default EventCard;